module.exports = __webpack_public_path__ + "static/oval-2-copy.6ed89fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/oval/oval-2-copy.png
// module id = 681
// module chunks = 35783957827783